import React, { Component } from "react";
import { FormGroup, CardHeader, Media, Input, Modal } from "reactstrap";
import {
  Col,
  Row,
  Card,
  Form,
  

} from "@themesberg/react-bootstrap";
import "@pathofdev/react-tag-input/build/index.css";
import SpinDiv from "../components/SpinDiv";
import { toast } from "react-toastify";
import { addTraining } from "../../services/trainingService";
import { getTrainers } from "../../services/trainerService";
import {getTrainingTypes} from "../../services/trainingTypeService"
import AsyncSelect from "react-select/async";
import ReactDatetime from "react-datetime";
import moment from "moment";
import { getBranches } from "../../services/branchService";
import { Progress, Button } from 'antd';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';


export class AddTraining extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      page: 1,
      rows: 10,
      loading: false,
      title: '',
      amount: '',
      progress: 10,
      branches: props.branches,
      trainers:props.trainers,
      training_types:props.training_types,
      employees: props.employees.map((opt) => ({
        label: opt.name,
        value: opt.id,
      })),
      start_date: moment().startOf('month'),
      end_date: moment().endOf('month')
    };
  }

  componentDidMount() {
    toast.configure({ hideProgressBar: true, closeButton: false });
    // this.getTrainingTypes();
    // this.getBranches();
    // this.getTrainers();
  }

  onChange = (e, state) => {
    this.setState({ [state]: e });
  };

  increase = () => {
    let progress = this.state.progress + 10;
    if (progress > 100) {
      progress = 100;
    }
    this.setState({ progress });
  };

  decline = () => {
    let progress = this.state.progress - 10;
    if (progress < 0) {
      progress = 0;
    }
    this.setState({ progress });
  };

  showToastError = (msg) => {
    toast(<div style={{ padding: 20, color: "red" }}>{msg}</div>);
  };


  getEmployees = (inputValue) => {

    return this.state.employees.filter((i) =>
      i.label.toLowerCase().includes(inputValue.toLowerCase())
    );
  };
  loadEmployees = (inputValue, callback) => {
    setTimeout(() => {
      callback(this.getEmployees(inputValue));
    }, 1000);
  };

  // getTrainingTypes = async () => {

  //   getTrainingTypes().then(

  //     (res) => {
  //       this.setState({
  //         training_types: res.training_types.data,
  //       });
  //     },
  //     (error) => {
  //       this.setState({ loading: false });
  //     }
  //   );
  // };

  // getTrainers = async () => {

  //   this.getTrainers().then(

  //     (res) => {
  //       this.setState({
  //         trainers: res.trainers.data,
  //       });
  //     },
  //     (error) => {
  //       this.setState({ loading: false });
  //     }
  //   );
  // };

  // getBranches = async () => {

  //   getBranches().then(

  //     (res) => {
  //       this.setState({
  //         branches: res.branches.data,
  //       });
  //     },
  //     (error) => {
  //       this.setState({ loading: false });
  //     }
  //   );
  // };




  onSaveTraining = async (e) => {
    e.preventDefault();
    await toast.dismiss();
    const { branch_id, milestone, trainer_id, training_option, training_type_id,
       start_date, title, progress, end_date, employee_id, validation } = this.state;
    await this.setState({
      validation: {
        ...validation,
        employee_id: employee_id !== '' && employee_id !== undefined,
        training_type_id: training_type_id !== '' && training_type_id !== undefined,
        trainer_id: trainer_id !== '' && trainer_id !== undefined,
        branch_id: branch_id !== '' && branch_id !== undefined,
        start_date: start_date !== '' && start_date !== undefined,
        end_date: end_date !== '' && end_date !== undefined,
        milestone: milestone !== '' && milestone !== undefined,
        training_option: training_option !== '' && training_option !== undefined,
        title: title !== '' && title !== undefined,
        progress: progress !== '' && progress !== 0,
      },
    });
    if (Object.values(this.state.validation).every(Boolean)) {
      this.saveTraining();
    } else {
      const errors = Object.keys(this.state.validation).filter((id) => {
        return !this.state.validation[id];
      });
      //await toast.configure({hideProgressBar: true, closeButton: false});
      toast.dismiss();
      toast.configure({ hideProgressBar: true, closeButton: false });

      toast(
        <div style={{ padding: "10px 20px" }}>
          <p style={{ margin: 0, fontWeight: "bold", color: "red" }}>Errors:</p>
          {errors.map((v) => (
            <p key={v} style={{ margin: 0, fontSize: 14, color: "red" }}>
              * {this.validationRules(v)}
            </p>
          ))}
        </div>
      )
    }
  };


  validationRules = (field) => {
    if (field === "employee_id") {
      return "Employee Name  is required";
    } else if (field == 'training_type_id') {
      return "Training type is required"
    } else if (field == 'training_option') {
      return "Training option is required"
    } else if (field == 'start_date') {
      return "Start Date is required"
    } else if (field == 'end_date') {
      return "End Date is required"
    } else if (field == 'milestone') {
      return "milestone is required"
    } else if (field == 'trainer_id') {
      return "Trainer is required"
    }else if (field == 'training_option') {
      return "Trainer option is required"
    }else if (field == 'title') {
      return "Title is required"
    }else if (field == 'progress') {
      return "Progress is required"
    }else if (field == 'branch_id') {
      return "Branch is required"
    }
  };

  dateFilter = async (e, state) => {
    await this.setState({ [state]: e })

  }

  saveTraining = () => {
    this.setState({ saving: true });
    const { branch_id, progress, milestone, trainer_id, training_option, training_type_id,
     start_date, end_date, title, employee_id } = this.state;
    console.log();
    addTraining({
      employee_id: employee_id,
      training_type_id: training_type_id,
      trainer_id: trainer_id,
      branch_id: branch_id,
      start_date: start_date,
      end_date: end_date,
      milestone: milestone,
      training_option: training_option,
      title: title,
      progress:progress


    }).then(
      (res) => {
        console.log(res);
        this.setState({ loading: false });
        this.props.saved();
        this.props.toggle();
        this.showToast("Training has been created");
      },
      (err) => {

        if (err) {
          toast.dismiss();
          toast.configure({ hideProgressBar: true, closeButton: false });
          if (err) {
            this.showToastError('An error occured')
          }
          this.setState({ saving: false });
        }
        this.setState({ loading: false });
      }
    );
  };

  showToast = (msg) => {
    toast(<div style={{ padding: 20 }}>{msg}</div>);
  };

  render() {
    const { employees, toggle } = this.props;

    const { saving,  branches, trainers, start_date, end_date, training_types, employee_id, training_type_id,
       training_option, progress, title,trainer_id, branch_id, milestone, loading } = this.state;
    return (
      <>
        <Modal
          className="modal-dialog modal-dialog-centered"
          isOpen={employees != null}
          toggle={() => !loading && !saving && toggle}
          style={{ maxWidth: 700 }}
        >
          {loading && <SpinDiv text={"loading..."} />}
          {saving && <SpinDiv text={"Saving..."} />}
          <div className="modal-header" style={{ padding: "1rem" }}>
            <div className="btn-toolbar mb-2 mb-md-0">
              <h5>Create Training</h5>
            </div>

            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={toggle}
            ></button>
          </div>
          <Card border="light" className="shadow-sm mb-4">
            <Card.Body className="pb-0">
              <Row>
              <Col md={12} style={{ paddingTop: 15 }}>
                  <Form.Group className="mb-2">
                    <Form.Label style={{ paddingRight: 10 }}>Training Title</Form.Label>
                    <Input
                      className="custom-control-input"
                      id="title"
                      placeholder='Enter Title'
                      value={title}
                      onChange={async (e) => {
                        await this.onChange(e.target.value, "title");
                      }}
                      type="text"
                    />
                  </Form.Group>

                </Col>
              </Row>
              <Row>
                <Col md={6}>

                  <Form.Group>
                    <Form.Label>Choose Employee</Form.Label>
                    <AsyncSelect
                      cacheOptions
                      defaultOptions
                      loadOptions={this.loadEmployees}
                      onInputChange={this.handleInputChange}
                      onChange={async (property, value) => {
                        console.log(property);
                        await this.setState({
                          employee_id: property.value,
                          selectedEmployee: property.label,
                        });
                      }}
                    />
                  </Form.Group>

                </Col>
                <Col md={6} >
                  <Form.Group className="mb-2">
                    <Form.Label>Training Type</Form.Label>

                    <Form.Select
                      id="state"
                      required
                      value={training_type_id}
                      onChange={async (e) => {
                        await this.onChange(e.target.value, "training_type_id");
                      }}
                      style={{
                        marginRight: 10,
                        width: "100%",
                      }}
                    >

                      <option value="">Choose Training Type</option>
                      {training_types.length == 0 && <option value="">loading</option>}
                      {training_types.map((p, index) => (
                        <option value={p.id} key={p}>
                          {p.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>

                </Col>

              </Row>
              <Row>
                <Col md={6} >
                  <Form.Group className="mb-2">
                    <Form.Label>Trainer</Form.Label>

                    <Form.Select
                      id="state"
                      required
                      value={trainer_id}
                      onChange={async (e) => {
                        await this.onChange(e.target.value, "trainer_id");
                      }}
                      style={{
                        marginRight: 10,
                        width: "100%",
                      }}
                    >

                      <option value="">Choose Trainer</option>
                      {trainers.length == 0 && <option value="">loading</option>}
                      {trainers.map((p, index) => (
                        <option value={p.id} key={p}>
                          {p.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>

                </Col>
                <Col md={6} >
                  <Form.Group className="mb-2">
                    <Form.Label>Branch</Form.Label>

                    <Form.Select
                      id="state"
                      required
                      value={branch_id}
                      onChange={async (e) => {
                        await this.onChange(e.target.value, "branch_id");
                      }}
                      style={{
                        marginRight: 10,
                        width: "100%",
                      }}
                    >

                      <option value="">Choose Branch</option>
                      {branches.length == 0 && <option value="">loading</option>}
                      {branches.map((p, index) => (
                        <option value={p.id} key={p}>
                          {p.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>

                </Col>
              </Row>
              <Row>
                <Col md={6} >
                  <Form.Group className="mb-2">
                    <Form.Label>Training Option</Form.Label>

                    <Form.Select
                      id="state"
                      required
                      value={training_option}
                      onChange={async (e) => {
                        await this.onChange(e.target.value, "training_option");
                      }}
                      style={{
                        marginRight: 10,
                        width: "100%",
                      }}
                    >

                      <option value="">Choose Training Option</option>
                      <option value="Internal">Internal</option>
                      <option value="External">External</option>

                    </Form.Select>
                  </Form.Group>

                </Col>
                
              </Row>
              <Row>
                <Col md="6">
                  <FormGroup className="form-date">
                    <label
                      className="form-control-label"
                      htmlFor="input-address"
                    >
                      Start Date
                    </label>
                    <ReactDatetime
                      value={start_date}
                      dateFormat={'MMM D, YYYY'}
                      closeOnSelect
                      onChange={e => this.dateFilter(e, 'start_date')}
                      inputProps={{
                        required: true,
                        className: 'form-control date-width'
                      }}
                      timeFormat={false}
                    />
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup className="form-date">
                    <label
                      className="form-control-label"
                      htmlFor="input-address"
                    >
                      End Date
                    </label>
                    <ReactDatetime
                      value={end_date}
                      dateFormat={'MMM D, YYYY'}
                      closeOnSelect
                      onChange={e => this.dateFilter(e, 'end_date')}
                      inputProps={{
                        required: true,
                        className: 'form-control date-width'
                      }}
                      style={{ width: '100%' }}
                      //isValidDate={(current)=>{return (current.isAfter(start_date)||current.isSame(start_date));}}
                      timeFormat={false}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md={6} style={{ paddingTop: 15 }}>
                  <Form.Group className="mb-2">
                    <Form.Label style={{ paddingRight: 10 }}>Expected milestone </Form.Label>
                    <Input
                      className="custom-control-input"
                      id="reason"
                      placeholder='Enter Milestone'
                      value={milestone}
                      onChange={async (e) => {
                        await this.onChange(e.target.value, "milestone");
                      }}
                      type="textarea"
                    />
                  </Form.Group>

                </Col>
                <Col md={6}>
                  <Form.Label style={{ paddingRight: 10 }}>Training Progress</Form.Label>
                  <Progress type="circle"  onChange={e=>this.onChange(e, 'progress')} value={progress} percent={progress} />
                  <Button.Group>
                    <Button onClick={this.decline} icon={<MinusOutlined />} />
                    <Button onClick={this.increase} icon={<PlusOutlined />} />
                  </Button.Group>
                </Col>

              </Row>
              <Row>

              </Row>
              <Row style={{ marginTop: "10px" }}>
                <Col md={12}>
                  <div>
                    <Button
                      variant="primary"
                      size="sm"
                      style={{ marginTop: "10px", float: "right" }}
                      disabled={saving}
                      onClick={this.onSaveTraining}
                    >
                      Save
                    </Button>
                    <Button
                      size="sm"
                      variant="transparent"
                      data-dismiss="modal"
                      type="button"
                      disabled={saving}
                      style={{ marginTop: "10px", float: "right" }}
                      onClick={toggle}
                    >
                      {" "}
                      Close
                    </Button>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Modal>
      </>
    );
  }
}

export default AddTraining;
